












import Vue from "vue";
import { mapState } from "vuex";
import { v4 as uuidv4 } from "uuid";

import iwInputText from "@/encoding/components/buildingBlocks/InputText.vue";

import { CustomerApiError } from "@/shared/interfaces/customer/Customer.interface";

import { internationalizePhoneNumber } from "@/shared/scripts/phoneNumber";

export default Vue.extend({
    components: {
        iwInputText: iwInputText,
    },
    data: function() {
        return {
            pathInStore: "contactDetails.landline.number",
            specificId: uuidv4() as string,
            errorMessage: "" as string,
        };
    },
    computed: {
        ...mapState("CustomersModule", [
            "currentCustomer",
            "customerApiErrors",
            "initialCustomer",
        ]),

        phoneNumber: function(): string | null {
            return this.currentCustomer?.contactDetails?.landline?.number
                ?? this.$store.getters["FormModule/getValueUI"]("customer." + this.pathInStore)
            ?? null; // dirty indent created by the linter ¯\_(ツ)_/¯
        },
    },
    watch: {
        customerApiErrors: function(errors) {
            errors.forEach((error: CustomerApiError) => {
                const path = error.dataPath.substring(1);

                if (path === this.pathInStore) {
                    this.errorMessage = error.message;
                }
            });
        }
    },
    methods: {
        updateText: function (event: Event) {
            const target = event.target as HTMLInputElement;
            const value = internationalizePhoneNumber(target.value, "+32");

            if (!this.currentCustomer) {
                return this.$store.commit("FormModule/addValueUI", {
                    path: "customer." + this.pathInStore,
                    value: value,
                });
            }

            this.$store.commit("CustomersModule/addValue", {
                path: this.pathInStore,
                value: value,
            });

            if (this.initialCustomer) {
                const newNumber = value;
                const number = this.initialCustomer?.contactDetails?.landline?.number;
                this.$store.commit("CustomersModule/setIsCustomerContactDetailsChange", newNumber != number);
            }
        }
    }
});
